@if (isAllLoaded$ | async) {
  <div class="flex flex-col flex-1 w-full relative">
    <div
      class="sticky top-0 z-10 flex flex-row w-full bg-white items-center gap-3 px-5 py-3 border-b border-solid border-navy-40"
    >
      <div class="flex items-center pr-3 border-r border-navy-40 gap-x-3">
        @for (tab of tabs; track $index) {
          <app-new-button
            [type]="'secondary'"
            [size]="'responsive'"
            [svgIconPath]="tab.icon"
            [isActive]="currentTabId === tab.tabId"
            (click)="changeTab(tab.tabId)"
          >
            {{ tab.translationKey | translate: { count: tab.count || 0 } }}
          </app-new-button>
        }
      </div>

      <app-new-button
        data-test-id="invite-button"
        [type]="'basic'"
        [svgIconPath]="'add_users'"
        [size]="'responsive'"
        (click)="inviteUser()"
      >
        {{ buildTranslationKey('inviteUser') | translate }}
      </app-new-button>

      <app-new-button
        data-test-id="add-company-button"
        [type]="'basic'"
        [svgIconPath]="'Add'"
        [size]="'responsive'"
        (click)="addCompany()"
      >
        {{ buildTranslationKey('addCompany') | translate }}
      </app-new-button>

      @switch (currentTabId) {
        @case (Tabs.Requests) {
          <app-data-search
            class="ml-auto w-55"
            [placeholderTranslationKey]="buildTranslationKey('search')"
            [routeParamsDisabled]="true"
            [data]="openRequests"
            [searchDefinitions]="userSearchDefinitions"
            [disabled]="!openRequests.length"
            (search)="handleRequestsSearch($event)"
          ></app-data-search>
        }

        @case (Tabs.Companies) {
          <app-data-search
            class="ml-auto w-55"
            [placeholderTranslationKey]="buildTranslationKey('search')"
            [routeParamsDisabled]="true"
            [data]="companies"
            [searchDefinitions]="companySearchDefinitions"
            [disabled]="!companies.length"
            (search)="handleCompaniesSearch($event)"
          ></app-data-search>
        }

        @case (Tabs.Users) {
          <app-data-search
            class="ml-auto w-55"
            [placeholderTranslationKey]="buildTranslationKey('search')"
            [data]="otherRequests"
            [searchDefinitions]="userSearchDefinitions"
            [disabled]="!otherRequests.length"
            (search)="handleOtherRequestsSearch($event)"
          ></app-data-search>
        }
      }
    </div>

    <div class="content-container bg-navy-30 h-full p-5">
      <app-requests-renderer
        [class.hidden]="currentTabId !== Tabs.Requests"
        [allRequests]="filteredOpenRequests$ | async"
        (openAccessManagerTab)="goToAccessManagerTab()"
      ></app-requests-renderer>

      <app-companies-renderer
        [class.hidden]="currentTabId !== Tabs.Companies"
        [allCompanies]="filteredCompanies$ | async">
      </app-companies-renderer>

      <app-access-manager-renderer
        [class.hidden]="currentTabId !== Tabs.Users"
        [allUsersWithAccess]="filteredOtherRequests$ | async"
      ></app-access-manager-renderer>
    </div>
  </div>
} @else {
  <div class="w-full h-full bg-navy-30">
    <app-loading-animation [width]="'270px'" [height]="'270px'"></app-loading-animation>
  </div>
}
